/** 发品槽位图片 → 可供 AI / 侵权检测使用的 URL */
export function resolvePublishSlotImageUrl(img) {
  if (!img || typeof img !== 'object') return '';
  return String(
    img.ipeUrl || img.publicUrl || img.url || img.previewUrl || img.sheinUrl || '',
  ).trim();
}
